import { render, staticRenderFns } from "./IconSvgGroup.vue?vue&type=template&id=63ff0118&scoped=true&"
import script from "./IconSvgGroup.vue?vue&type=script&lang=js&"
export * from "./IconSvgGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ff0118",
  null
  
)

export default component.exports